import axios from "axios";
import { chefActions } from "./chefSlice";
import { API_LOCAL, API_TEST, EVENING_SHIFT_END_TIME, EVENING_SHIFT_START_TIME } from "./constants";
import { toast } from "react-toastify";

export const getKitchenStatus = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axios.get("getKitchenStatus");
      if (response.status != 200) {
        throw new Error("Could not fetch Chef list");
      }
      const data = response.data.data;
      return data;
    };

    try {
      const data = await fetchData();
      dispatch(chefActions.setKitchenStatus(data));
    } catch (error) {
      console.log("error while calling getKitchenStatus");
      // show error on ui
    }
  };
};

export const fetchChefList = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axios.get("chef");
      if (response.status !== 200) {
        throw new Error("Could not fetch Chef list");
      }
      return response.data.data;
    };

    try {
      const data = await fetchData();
      const now = new Date().getHours();
      let sortedData = [];

      if (now >= EVENING_SHIFT_START_TIME || now < EVENING_SHIFT_END_TIME) {
        sortedData = data.sort((a, b) => a.shift - b.shift || a.listRank - b.listRank);
      } else {
        sortedData = data.sort((a, b) => b.shift - a.shift || a.listRank - b.listRank);
      }

      dispatch(chefActions.replaceChefList({ chefList: sortedData }));

      // Extract chef IDs
      const chefIds = sortedData.map((chef) => chef._id);

      // Fetch categories for all chefs concurrently
      await Promise.all(chefIds.map((chefId) => dispatch(fetchCategories(chefId))));
      dispatch(chefActions.setCategoriesLoaded());
      await Promise.all(chefIds.map((chefId) => dispatch(fetchChefWaitingTime(chefId))));

    } catch (error) {
      console.log("Error while calling chef-fetchdata:", error);
      // Show error on UI
    }
  };
};

export const fetchKitchensList = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axios.get("user/getKitchens");
      if (response.status != 200) {
        throw new Error("Could not fetch kitchen list");
      }
      const data = response.data.data;
      return data;
    };

    try {
      const data = await fetchData();
      dispatch(chefActions.setKitchenList(data));
    } catch (error) {
      console.log("error while calling kitchen list");
      // show error on ui
    }
  };
};

const getWeekNumberInMonth = (date) => {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

  const weekNumber = Math.ceil((date.getDate() + firstDayOfMonth.getDay()) / 7);
  return weekNumber;
}

export const fetchCategories = (chefId) => {
  
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axios.get("menu/chef/categories/" + chefId);
      if (response.status != 200) {
        throw new Error("Could not fetch Chef list");
      }
      const data = response.data.data;
      return data;
    };
    const currentDate = new Date();
    const currentWeekdayNumber = currentDate.getDay();

    try {
      const data = await fetchData();
      const categories = [...data.dailySpecial, ...data.weeklySpecial, ...data.categories];
      const categoriesList = categories.map((item) => {
        const allDishes = [...item.dishes]
        if (item?.type == "daily") {
          const currentDishes = allDishes.find((a) => a.weekDay === currentWeekdayNumber);
          item.dishes = currentDishes?.dishes || []
        } else if (item?.type == "weekly") {
          const currentDate = new Date();
          const weekNumberInMonth = getWeekNumberInMonth(currentDate);
          const currentDishes = allDishes.find((a) => a.weekNumber === weekNumberInMonth);
          item.dishes = currentDishes?.dishes || []
        }
        return item;
      });
      const filterCategoriesList = categoriesList.filter((a) => a.dishes.length);

      dispatch(
        chefActions.replaceCategories({
          categories: filterCategoriesList,
          chefId: chefId,
          id: data._id
        })
      );
    } catch (error) {
      console.log("error while calling categories-fetchdata");
      // show error on ui
    }
  };
};

export const fetchChefWaitingTime = (chefId) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await axios.get("getDeliveryDelayTimeByChef/" + chefId);
      if (response.status != 200) {
        throw new Error("Could not fetch Chef Time");
      }
      const data = response.data.data;
      return data;
    };

    try {
      const data = await fetchData();
      dispatch(
        chefActions.setChefWaitingTime({
          time: data,
          chefId: chefId,
        })
      );
    } catch (error) {
      console.log("error while calling categories-fetchdata");
      // show error on ui
    }
  };
};

export const createDineInReservation = (body) => async (dispatch) => {
  dispatch(
    chefActions.setReservationBooking({
      createReservationBookingLoading: true
    })
  );
  try {
    const { data } = await axios.post("reservation", body);
      if (data.data)
      dispatch(
        chefActions.setReservationBooking({
          createReservationBookingLoading: false
        })
      );
      toast.success("Booking successfull");
  } catch (error) {
    toast.error("error while dine in reservation");
    dispatch(
      chefActions.setReservationBooking({
        createReservationBookingLoading: false
      })
    );
    // show error on ui
  }
};


export const getUserDineinReservation = (userId) => async (dispatch) => {
  try {
    if (userId) {
      const { data } = await axios(`reservation/${userId}`);
      if (data.data) dispatch(chefActions.setDineInBooking({ dineInBooking: data.data }));
    }
  } catch ({ ...error }) {
    console.log(error);
  }
};

